/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa loan calculator
 *
 */
Intesa.LoanCalculatorAlex = function() {

    /**
     * Local variables
     *
     */
    var loan = this;
    var development = false;
    var invalidJsonFiles = false;
    var lang = $('html')[0].getAttribute('lang');
    this.calculatorData = {};
    this.calculatorLabels = {};
    try {
        var genericSettings = JSON.parse($("#genericSettings").val());
    } catch (e) {
    	console.log("an error occurred while getting config " + e);
        invalidJsonFiles = true;
    }
    var arabNumbers = ["&#1632;", "&#1633;", "&#1634;", "&#1635;", "&#1636;", "&#1637;", "&#1638;", "&#1639;", "&#1640;", "&#1641;"];

    /**
     * Global variables
     *
     */
    this.loanAmount = 0;
    this.annualInterestRate = 0;
    this.tenorInMonths = 0;
    this.monthlyNETIncome = 0;
    this.monthlyNETIncome35Percent = 0;
    this.monthlyInstallment = 0;
    this.carValue = null;
    this.downPayment = 0;
    this.productVariants = [];
    this.activeVariant = {};
    this.activeInterestType = {};
    this.activeTab = 0;
    this.errorState = false;
    this.error35State = false;
    this.errorCarState = false;
    this.urlParams = {};
    this.activeCalculator = null;
    this.isdefaultElement = "true";

    /**
     * Init component
     *
     */
    this.init = function() {

        // check if calculator exixts
        if (!$("section.com16-11").length) return;

        // check if all JSON files are valid
        if (invalidJsonFiles) {
            loan.showErrorMessage();
            return;
        }

        loan.setVisibleCalculatorAsActive();
        if(loan.activeCalculator){
        	console.log("finding labels and data");
        	loan.calculatorData = JSON.parse( loan.activeCalculator.siblings('#calculatorData').val());
        	loan.calculatorLabels = JSON.parse(loan.activeCalculator.siblings("#calculatorLabels").val());
        } else {
        	console.log("can't find json configuration please check");
        }
        var calculatorNavigation = Intesa.CalculatorNavigation.getInstance(loan.activeCalculator);
        calculatorNavigation.currentTab = 0;
        calculatorNavigation.init();
        loan.setNumSystem(".loan_arab_language");
        loan.setNumSystem(".monthly_arab_language");
        loan.setNumSystem(".car_arab_language");
        loan.setNumSystem(".carmonthly_arab_language");
        loan.setNumSystem(".carborrow_arab_language");

        // init methods
        loan.mapProductVariants();
        loan.getUrlQueryStringParams();
        loan.setVariantInitValue();
        loan.setTabInitValue();
        loan.setInterestTypeInitValue();
        loan.addPurposeSelectOptions();

        // attach on change events
        loan.attachChangeEvents();

        // refresh values items
        loan.updateCalculatorInputs('urlParams');
        loan.handleNoMoreThan65YearsLong();
        loan.updateCalculatorOutputs();

    };


    /**
     * Generate Translated Number
     *
     */
    this.generateTranslatedNumber = function(number) {
        var isArab = $('html').attr('dir') === 'rtl';

        // check if it's an arab page
        if (number !== undefined && isArab) {

            number = loan.translateInArabicNumber(number);

        }

        return number;

    };


    /**
     * Translate In Arabic Number
     *
     */
    this.translateInArabicNumber = function(number) {

        var arabNumber = "";

        number = number.toString();

        for (var i = 0; i < number.length; i++) {

            // if . or , not translate it
            if (isNaN(number[i]) || number[i] === '') {

                arabNumber += number[i];

            } else {

            	arabNumber += number.charAt(i) == ',' || number.charAt(i) == ' ' ? ',' : arabNumbers[parseInt(number.charAt(i))];

            }

        }

        return arabNumber;

    };


    /**
     * Set Variant Init Value
     *
     */
    this.setVariantInitValue = function() {

        var defaultVariant = loan.getDefaultVariantLabel();
        var activeVariant = loan.urlParams.loanPurpose ? loan.urlParams.loanPurpose : defaultVariant;
        loan.setActiveVariant(activeVariant);

    };


    /**
     * Set Tab Init Value
     *
     */
    this.setTabInitValue = function() {

        var activeTab = loan.urlParams.isDefault === 'false' ? false : true;
        loan.setActiveTab(activeTab, true);

    };


    /**
     * Set Interest Type Init Value
     *
     */
    this.setInterestTypeInitValue = function() {

        var defaultInterestType = loan.getDefaultInterestTypeLabel();
        var activeInterestType = loan.urlParams.interestType ? loan.urlParams.interestType : defaultInterestType;
        loan.setActiveInterestType(activeInterestType);

    };


    /**
     * Update Calculator Inputs
     *
     */
    this.updateCalculatorInputs = function(setValue) {

        loan.updateTabsNumber();
        loan.updateInterestTypesSelect();
        loan.updateMonthlyIncomeInput(setValue);
        loan.updateCarValueInput(setValue);
        loan.updateLoanAmountInput(setValue);
        loan.updateTenorInMonthsSlider(setValue);
        loan.updateAgeSlider(setValue);
        loan.formatMoneyInputs();
        
        //Update Default Arabic Value when change TAB
        $('[name="monthlyNETIncomeValueAR"]', loan.activeCalculator).val(loan.getInputValue( $('[name="monthlyNETIncomeValue"]', loan.activeCalculator) )).trigger("keyup");
        $('[name="borrowAmoutValueAR"]', loan.activeCalculator).val($('[name="borrowAmoutValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");
        $('[name="carValueAR"]', loan.activeCalculator).val($('[name="borrowAmoutValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");

    };


    /**
     * Update Calculator Outputs
     *
     */
    this.updateCalculatorOutputs = function() {
        loan.checkErrors();
        loan.getCalculatorInputs();
        loan.calculateMonthlyInstallment();
        loan.calculateDownPayment();
        loan.check35PercentErrors();
        loan.checkCarValueError();
        loan.appendCalculatorOutputs();
        loan.updateCallBackJsonValues();
        loan.updateShareCalculatorLink();
        if (development) loan.consoleLogValues();

        loan.changeValueInput(".loan_arab_language");
        loan.changeValueInput(".monthly_arab_language");
        loan.changeValueInput(".car_arab_language");
        loan.changeValueInput(".carmonthly_arab_language");
        loan.changeValueInput(".carborrow_arab_language");

    };


    /**
     * Update Share Calculator Link
     *
     */
    this.updateShareCalculatorLink = function() {

        // get url without query string
        var currentURL = window.location.href;
        currentURL = currentURL.split('?');
        currentURL = currentURL[0];

        // get age
        var age = parseInt($('[data-algorithm-input="age"]', loan.activeCalculator).val());

        // add standard query params
        var queryParams = '?loanPurpose=' + loan.activeVariant.name +
            '&loanAmount=' + loan.loanAmount +
            '&tenor=' + loan.tenorInMonths +
            '&age=' + age +
            '&monthlyIncome=' + loan.monthlyNETIncome +
            '&interestType=' + loan.activeInterestType.code +
            '&isDefault=' + loan.activeTab.isDefault +
            '&carValue=' + loan.carValue;

        // update link
        //$( '#share-calculator' ).text( currentURL + queryParams );


        //custom url for data-socialshare
        if ($('[data-socialshare]', loan.activeCalculator).length > 0) {

            $('[data-socialshare]', loan.activeCalculator).each(function() {

                if ($(this).attr("data-socialshare") == "facebook") {

                    $(this).attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + currentURL + queryParams);

                }

                if ($(this).attr("data-socialshare") == "twitter") {

                    $(this).attr("href", "https://twitter.com/home?status=" + currentURL + queryParams);

                }

                if ($(this).attr("data-socialshare") == "linkedin") {

                    $(this).attr("href", "https://www.linkedin.com/sharing/share-offsite/?url=" + currentURL + queryParams);

                }

                if ($(this).attr("data-socialshare") == "whatsapp") {

                    $(this).attr("href", " https://wa.me/?text=" + encodeURIComponent(currentURL) + encodeURIComponent(queryParams));

                }

                if ($(this).attr("data-socialshare") == "mail") {

                    $(this).attr("href", "mailto:?body=" + currentURL + encodeURIComponent(queryParams));

                }

            });
        }

    };

    /**
     * Check Car Value Error
     *
     */
    this.checkCarValueError = function() {

        var carError = $('[data-car-error]', loan.activeCalculator);
        var carInput = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);
        var carErrors = carInput.parents('.spaceBottom').find('.parsley-errors-list li');

        var currentCarValue = loan.carValue;

        var downPayment = loan.activeTab.data.downPayment;

        if (downPayment !== null && downPayment !== undefined) {

            currentCarValue = loan.carValue - (loan.carValue * (loan.activeTab.data.downPayment / 100));

            $('[data-car-error-msg="withoutsalary"] b', loan.activeCalculator).replaceWith("{value}");
            $('[data-car-error-msg="withsalary"]', loan.activeCalculator).hide();
            $('[data-car-error-msg="withoutsalary"]', loan.activeCalculator).show().html($('[data-car-error-msg="withoutsalary"]', loan.activeCalculator).html().replace(/{value}/g, '<b>' + number_format(currentCarValue, 0, genericSettings.decimal_number, genericSettings.separator_number) + '</b>'));

        } else {

            $('[data-car-error-msg="withsalary"]', loan.activeCalculator).show();
            $('[data-car-error-msg="withoutsalary"]', loan.activeCalculator).hide();

        }

        var isAmountMoreThanCarValue = loan.loanAmount > currentCarValue;
        var thereAreNoErrors = loan.errorState === false && loan.error35State === false;

        // if input exist
        if (carInput.length && carError.length) {

            if (isAmountMoreThanCarValue && thereAreNoErrors) {

                // show error
                this.errorCarState = true;
                carError.removeClass('hide');

                carInput.removeClass('parsley-success');
                carInput.addClass('parsley-error');

            } else {

                // hide error
                this.errorCarState = false;
                carError.addClass('hide');

                if (!carErrors.length) {

                    carInput.addClass('parsley-success');
                    carInput.removeClass('parsley-error');
                }

            }

        }

    };

    /**
     * Get Url Query String Params
     *
     */
    this.getUrlQueryStringParams = function() {

        // get url
        var currentURL = window.location.href;
        currentURL = currentURL.split('?');

        // get query params
        var queryString = currentURL[1];

        // check query string not empty
        if (queryString !== undefined) {

            var params = queryString.split('&');

            params.forEach(function(param) {

                var property = param.split('=');
                var propertyName = property[0];
                var propertyValue = property[1];

                // set loan.urlParams property
                loan.urlParams[propertyName] = propertyValue;

            });

        }

    };


	/**
	 * Set Visible Calculator As Active
	 *
	 */
	this.setVisibleCalculatorAsActive = function() {
		var width = $(window).width();
		var calculatorResolution = "desktop" ;
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		var calculators = $( '[data-calculator='+calculatorResolution+']' );
		var calculatorFound = false;

		calculators.each( function() {

			// set visible calculator as active
			if( $(this).is(":visible") ) {

				loan.activeCalculator = $( this );
				calculatorFound = true;

			}

		} );

		// handle no calculator active by default
		if( !calculatorFound ) loan.activeCalculator = $( '[data-calculator='+calculatorResolution+']' ).first();

	};
    
	/**
	 * Set Active Calculator
	 *
	 */
	this.setActiveCalculator = function( calculator ) {

		loan.activeCalculator = calculator;

	};

    /**
	 * Set Active Mortgage
	 *
	 */
	this.updateCalculatorConfigurationByTenor = function( currentTenor ) {

		var variantList = loan.activeVariant.data.glProductVariantList;
		var variantType = ""; 
		var v;
		// cicle all the martgage options
		var foundInterest = false; 

		// cerco in un altra variante un tasso di interesse nel range del tenor
		
		for (k = 0; (k < loan.activeVariant.data.glGenericCalculationList.length  || foundInterest); k++){
			
			var c = loan.activeVariant.data.glGenericCalculationList[k];
			
			var interestPeriodToCheck = c.interest[0].firstPeriod.monthDuration;
			if(c.interest[0].firstPeriod.monthDuration == null || c.interest[0].firstPeriod.monthDuration == 'null'){
				interestPeriodToCheck = c.interest[1].firstPeriod.monthDuration;
			}
			
			if(c.amountList[0].minimumTenor <= currentTenor && interestPeriodToCheck >=  currentTenor && c.amountList[0].maximumTenor >= currentTenor && loan.activeTab.data.standard == c.standard) {

				loan.activeTab = {
						'isDefault': c.isDefault,
						'data': c ,
					};
				foundInterest = true;
				
				break;

			}

		}
		
		if (!foundInterest){
			// se non trovo il tasso di interesse nel range assegno quello di default della variante e aggiorno il tenor	

			for (k = 0; (k < loan.activeVariant.data.glGenericCalculationList.length  || foundInterest); k++){
				
				var c = loan.activeVariant.data.glGenericCalculationList[k];
				
				if(c.isDefault) {

					loan.activeTab = {
							'isDefault': c.isDefault,
							'data': c ,
						};
					foundInterest = true;
					
					break;

				}

			}
			
//			loan.updateTenorUnit();
//			loan.updateTenorSlider();
			
		}

		loan.updateInterestTypesSelect();
	};
	
    /**
     * Attach Change Events
     *
     */
    this.attachChangeEvents = function() {

    	
		// on calculator change
		$( document ).on( 'click', '.com15__filterItem', function() {
			var id = $( this ).attr( 'data-filter' );
			var width = $(window).width();
			var calculatorResolution = "desktop" ;
			if(width < 768){
				var calculatorResolution = "mobile" ;
			}
			var calculator = $( '.com15__filter[data-filter="' + id + '"]' ).find( '[data-calculator='+calculatorResolution+']');
		//	loan['loanpurpose'] = id;
			loan.setActiveCalculator( calculator );
	        if(loan.activeCalculator){
	        	console.log("finding labels and data");
	        	loan.calculatorData = JSON.parse( loan.activeCalculator.siblings('#calculatorData').val());
	        	loan.calculatorLabels = JSON.parse(loan.activeCalculator.siblings("#calculatorLabels").val());
	        } else {
	        	console.log("can't find json configuration please check");
	        }
	        loan.productVariants = [];
	        var calculatorNavigation = Intesa.CalculatorNavigation.getInstance(loan.activeCalculator);
	        calculatorNavigation.currentTab = 0;
	        calculatorNavigation.init();
	        loan.mapProductVariants();
	        loan.getUrlQueryStringParams();
	        loan.setVariantInitValue();
	        loan.setTabInitValue();
	        loan.setInterestTypeInitValue();
	        loan.addPurposeSelectOptions();

	        // refresh values items
	        loan.updateCalculatorInputs('urlParams');
	        loan.handleNoMoreThan65YearsLong();
	        loan.updateCalculatorOutputs();
		} );

        // on change purpose
        $(document).on('change', '[data-purpose-select]', function() {

            var value = $(this).val();

            loan.setActiveVariant(value);
            loan.setActiveTab(true, true);
            loan.setActiveInterestType(loan.getDefaultInterestTypeLabel());
            loan.updateCalculatorInputs('default');
            loan.updateCalculatorOutputs();

        });

        // on change interest type
        $(document).on('change', '[data-interest-select]', function() {

            var label = $(this).find(':selected').attr('data-interest-code');

            loan.setActiveInterestType(label);
            loan.updateTenorInMonthsSlider();
            loan.updateCalculatorConfigurationByTenor(loan.tenorInMonths);
            loan.handleNoMoreThan65YearsLong();
            loan.updateCalculatorOutputs();

        });

        // on change tab
        $(document).on('click', '[data-tab-default]', function() {

            var defaultValue = $(this).attr('data-tab-default') === 'true' ? "true" : "false";

            loan.isdefaultElement = defaultValue;

            loan.setActiveTab(defaultValue, false);
            loan.updateCalculatorInputs();
            loan.handleNoMoreThan65YearsLong();
            loan.updateCalculatorOutputs();

        });

        // on change inputs
        $(document).on('change focusin focusout keyup', '[data-algorithm-input]', function() {

            // if it's age slider handle no more than 65 years long
            var isAgeSlider = $(this).attr('data-algorithm-input') === 'age';
            if (isAgeSlider) loan.handleNoMoreThan65YearsLong();

            loan.updateCalculatorOutputs();

        });


        // on change slider buttons
        $(document).on("click", '.js-btnMinus, .js-btnAdd', function() {

            var wrapper = $(this).parents('.sliderRange__wrapper');
            wrapper.find('.rangeslider').trigger('change');

        });

		$(document).on('keyup', 'input[data-algorithm-input="loanDurationMobile"]', function () {
            var slider = $('.rangeslider.rangeslider--3', loan.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
            $(this).val(loan.changeToLatin($(this).val()));
            $(this).parsley().validate();
            var valueLatin =loan.changeToLatin($(this).val());
            if(lang.indexOf("ar") > -1){
				if(isNaN(Number(loan.changeToLatin($(this).val())))){
					$(this).val('');
				} else {
					$(this).val(loan.changeToArab($(this).val().split("")));
				}
            }
            slider.slider('setValue', valueLatin, true);
            loan.updateCalculatorConfigurationByTenor(valueLatin);
		});


		$(document).on('change', "[data-algorithm-input=newInterest] input", function(){
			var $select = $("select[data-interest-select]", loan.activeCalculator);
         	var isFixed = $(this).attr("id").includes("fixed");
          	if(isFixed){
            	$select.find("option[data-interest-code='FIXED']").prop("selected",true);
            }else{
              	$select.find("option[data-interest-code='VARIABLE']").prop("selected",true);
            }
            $select.trigger("change");
		});
		$(document).on('change', "[data-algorithm-input=newPurpose] input", function(){
			var value = $( this ).val();
			var $select = $("select[data-purpose-select]", loan.activeCalculator);
            $select.val(value);
            $select.trigger("change");
		});
		
		$(document).on('keyup', 'input[data-algorithm-input="loanAge"]', function () {
            var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            $(this).parsley().validate();
            var index = parseInt(slider.attr('data-slider-index'));
            slider.slider('setValue', $(this).val(), true);
            slider.trigger('change');
            $('[name="loanAgeAr"]', loan.activeCalculator).val(loan.changeToArab($(this).val().split("")));
		});
		
		$(document).on('keyup', 'input[name="loanAgeAr"]', function () {
			var valueLatin =loan.changeToLatin($(this).val());
			if(isNaN(Number(valueLatin))){
				valueLatin = '';
			}
            $('input[data-algorithm-input="loanAge"]', loan.activeCalculator).val(valueLatin);
            $('input[data-algorithm-input="loanAge"]', loan.activeCalculator).parsley().validate();
			if(isNaN(Number(loan.changeToLatin($(this).val())))){
				$(this).val('');
			} else {
				$(this).val(loan.changeToArab($(this).val().split("")));
			}
            var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
            slider.slider('setValue', valueLatin, true);
            slider.trigger('change');

		});

        // enable change slider on click
        $(document).on("change", '.rangeslider', function() {

            // set slider value
            var value = $(this).val();
            var wrapper = $(this).parents('.sliderRange__wrapper');
            wrapper.find('.qty').val(value);
            wrapper.find('.valShow').html(loan.generateTranslatedNumber(value));

            // if it's age slider handle no more than 65 years long
            var isAgeSlider = $(this).siblings('[data-algorithm-input="age"]').length;
            if (isAgeSlider) loan.handleNoMoreThan65YearsLong();

            loan.updateCalculatorConfigurationByTenor(value);

            loan.updateCalculatorOutputs();

        });
    };


    /**
     * Update Call Back Json Values
     *
     */
    this.updateCallBackJsonValues = function() {
        var cmbInput = $('*[data-cmb-input]', loan.activeCalculator);

        if (cmbInput && cmbInput.length > 0) {
            var thereAreErrors = loan.errorState === true || loan.error35State === true || loan.errorCarState === true;
            var ageValue = parseInt($('[data-algorithm-input="age"]', loan.activeCalculator).val());

            var values = {
                "LOANAMOUNT": thereAreErrors ? 'N/A' : loan.loanAmount,
                "DURATION": thereAreErrors ? 'N/A' : loan.tenorInMonths,
                "INSTALLMENT": thereAreErrors ? 'N/A' : loan.monthlyInstallment,
                "MONTHLYINCOME": thereAreErrors ? 'N/A' : loan.monthlyNETIncome,
                "AGE": thereAreErrors ? 'N/A' : ageValue,
                "ISDEFAULT": thereAreErrors ? 'N/A' : loan.activeTab.data.isDefault,
                "INTERESTRATE": thereAreErrors ? 'N/A' : loan.annualInterestRate
            };

            if (loan.activeVariant.name !== null) {
                values.LOANPURPOSE = thereAreErrors ? 'N/A' : loan.activeVariant.name;
            }

            if (loan.carValue !== null) {
                values.CARVALUE = thereAreErrors ? 'N/A' : loan.carValue;
            }

            cmbInput.val(JSON.stringify(values));

        }

    };


    /**
     * Handle No More Than 65 Years Long
     *
     */
    this.handleNoMoreThan65YearsLong = function() {

        var tenorMax = loan.getVariantMaximumTenor();
        var tenorMaxInYears = tenorMax / 12;
        var age = parseInt($('[data-algorithm-input="age"]', loan.activeCalculator).val());
        var input = $('.rangeslider.rangeslider--3', loan.activeCalculator);
        var slider = input;
        var wrapper = input.parents('.sliderRange__wrapper');
        var currentValue = slider.slider('getValue');
        var forceMaxValue = false;
        var currentTenorMax = parseInt(input.attr('data-slider-max'));

        // calculate tenor max
        if ((tenorMaxInYears + age) >= 65) {

            var difference = (tenorMaxInYears + age) - 65;
            difference = difference * 12;

            tenorMax = Math.ceil(tenorMax - difference);

        }

        // if descending force slider value to max
        forceMaxValue = tenorMax > currentTenorMax && currentValue >= currentTenorMax ? true : false;

        // set new max
        input.attr('data-slider-max', tenorMax);

        // rebuild slider
        slider.slider('destroy');
        slider.slider();

        // set slider value
        if (currentValue >= tenorMax || forceMaxValue) {
            wrapper.find('.qty').val(tenorMax);
            wrapper.find('.valShow').html(loan.generateTranslatedNumber(tenorMax));
            slider.slider('setValue', tenorMax, true);
        } else {
            wrapper.find('.qty').val(currentValue);
            wrapper.find('.valShow').html(loan.generateTranslatedNumber(currentValue));
            slider.slider('setValue', currentValue, true);
        }

        // attach slide event
        loan.attachOnSlideEvent(slider, input, wrapper);

        // update max label
        wrapper.find('[data-max]').html(loan.generateTranslatedNumber(tenorMax));

    };


    /**
     * Update Tabs Number
     *
     */
    this.updateTabsNumber = function() {

        var tabs = loan.activeVariant.data.glGenericCalculationList;
        var numberOftabs = tabs.length;
        var tabsHTML = $('.com16__tabMenu', loan.activeCalculator);
        var tabsWrapper = $('.com16__tabContainer', loan.activeCalculator);


        // hide tabs HTML if there's only one tab
        if (numberOftabs <= 1) {
            tabsHTML.hide();
            tabsWrapper.css('padding-top', '40px');
        } else {
            tabsHTML.show();
            tabsWrapper.removeAttr("style");
        }

        $('[data-component="Com16_11"]', loan.activeCalculator).show();

    };


    /**
     * Calculate Down Payment
     *
     */
    this.calculateDownPayment = function() {

        loan.downPayment = loan.carValue * (loan.activeTab.data.downPayment / 100);

    };


    /**
     * Set Active Variant
     *
     */
    this.setActiveVariant = function(value) {

        // get variants array
        var variants = loan.productVariants;
        var numberOfVariants = variants.length;
        var variantFound = false;

        for (var i = 0; i < numberOfVariants; i++) {

            var variantName = variants[i].name;

            // set active variant
            if (variantName === value) {
                loan.activeVariant = variants[i];
                variantFound = true;
                break;
            }

        }

        // if variant not founded set default
        if (!variantFound) loan.setActiveVariant(loan.getDefaultVariantLabel());

    };


    /**
     * Set Active Interest Type
     *
     */
    this.setActiveInterestType = function(label) {

        var interestTypes = loan.activeTab.data.interest;
        var numberOfInterestTypes = interestTypes.length;
        var labelFound = false;

        for (var i = 0; i < numberOfInterestTypes; i++) {

            var currentInterest = interestTypes[i];

            if (currentInterest.interestCode === label) {
                loan.activeInterestType = {
                    'code': currentInterest.interestCode,
                    'maxTenor': currentInterest.firstPeriod.monthDuration
                };
                labelFound = true;
                break;
            }

        }

        // if label not found set default value
        if (!labelFound) {

            loan.activeInterestType = {
                'code': interestTypes[0].interestCode,
                'maxTenor': interestTypes[0].firstPeriod.monthDuration
            };

        }

    };


    /**
     * Check 35 Percent Errors
     *
     */
    this.check35PercentErrors = function() {

        var amountErrorMessage = $('[data-35-error="loanAmount"]', loan.activeCalculator);
        var tenorErrorMessage = $('[data-35-error="tenorInMonths"]', loan.activeCalculator);
        var loanAmountInput = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);
        var loanAmountErrors = loanAmountInput.parents('.spaceBottom').find('.parsley-errors-list li');
        var isInstallmentBiggerThanIncome35Percent = loan.monthlyInstallment > loan.monthlyNETIncome35Percent;

        // update error 35 messages
        loan.update35PercentErrorMessages();

        if (isInstallmentBiggerThanIncome35Percent && loan.errorState === false) {

            // update error 35 state
            loan.error35State = true;

            // update red line below loanAmount input
            loanAmountInput.removeClass('parsley-success');
            loanAmountInput.addClass('parsley-error');

            // add red color to loan amount error
            amountErrorMessage.removeAttr('style');

            // show tenor error message
            if (loan.loanAmount > loan.calculateMaximumLoanAmount(parseInt(loan.activeInterestType.maxTenor))) {
                tenorErrorMessage.addClass('hide');
            } else {
                tenorErrorMessage.removeClass('hide');
            }

        } else {

            // update error 35 state
            loan.error35State = false;

            // update red line below loanAmount input
            if (!loanAmountErrors.length) {
                loanAmountInput.addClass('parsley-success');
                loanAmountInput.removeClass('parsley-error');
            }

            // remove red color from amount error
            amountErrorMessage.css('color', '#4d4d4d');

            // hide tenor error message
            tenorErrorMessage.addClass('hide');

        }

    };


    /**
     * Update 35 Percent Error Messages
     *
     */
    this.update35PercentErrorMessages = function() {

        // loan amount error message
        var maxLoanAmount = loan.calculateMaximumLoanAmount();
        maxLoanAmount = loan.limitMaximumLoanAmount(maxLoanAmount);
        maxLoanAmount = number_format(maxLoanAmount, 0, genericSettings.decimal_number, genericSettings.separator_number);
        maxLoanAmount = loan.generateTranslatedNumber(maxLoanAmount);

        var valueString1 = '<b>' + maxLoanAmount + '</b>';
        loan.set35PercentErrorMessage('loanAmount', valueString1);

        // tenor slider error message
        var minMonthlyInstallment = loan.calculateMinimumTenor();
        minMonthlyInstallment = number_format(minMonthlyInstallment, 0, genericSettings.decimal_number, genericSettings.separator_number);
        minMonthlyInstallment = loan.generateTranslatedNumber(minMonthlyInstallment);
        var valueString2 = '<b>' + minMonthlyInstallment + '</b>';
        loan.set35PercentErrorMessage('tenorInMonths', valueString2);

    };


    /**
     * Limit Maximum Loan Amount
     *
     */
    this.limitMaximumLoanAmount = function(maxLoanAmount) {

        // get loan amount input max
        var inputMaxLoanAmount = loan.activeTab.data.maxAmountForOnline ? loan.activeTab.data.maxAmountForOnline : maxLoanAmount;

        // check if maxLoanAmount calculated is bigger than input max
        if (maxLoanAmount > inputMaxLoanAmount) {

            maxLoanAmount = inputMaxLoanAmount;

        }

        return maxLoanAmount;

    };


    /**
     * Change 35 Percent Error Message
     *
     */
    this.set35PercentErrorMessage = function(inputName, valueString) {

    	console.log("data-35-error" + inputName);
        var message = $('[data-35-error="' + inputName + '"]', loan.activeCalculator);

        var errorMsg = message.html();
        errorMsg = errorMsg.replace(/<b>(.*?)<\/b>/g, valueString); // replace <span>...</span>
        errorMsg = errorMsg.replace(/{value}/g, valueString); // replace {value}

        message.html(errorMsg);

    };


    /**
     * Check Errors
     *
     */
    this.checkErrors = function() {

        loan.checkInterestTypeTenorMaximum();
        loan.checkAgeMaximum();
        loan.updateErrorState();

    };


    /**
     * Update Error State
     *
     */
    this.updateErrorState = function() {

        var numberOfParsleyErrors = $('.parsley-errors-list li', loan.activeCalculator).length;
        var numberOfSliderErrors = $('.alertMessage.fc-error[data-max-error]', loan.activeCalculator).not('.hide').length;

        console.log($('.alertMessage.fc-error[data-max-error]', loan.activeCalculator));
        var thereAreErrors = numberOfParsleyErrors > 0 || numberOfSliderErrors > 0;

        if (thereAreErrors) {

            loan.errorState = true;

        } else {

            loan.errorState = false;

        }

    };


    /**
     * Get Default Interest Type Label
     *
     */
    this.getDefaultInterestTypeLabel = function() {

        var defaultLabel = loan.activeTab.data.interest[0].interestCode;

        return defaultLabel;

    };


    /**
     * Update Age Slider
     *
     */
    this.updateAgeSlider = function(setValue) {

        var input = $('.rangeslider.rangeslider--2', loan.activeCalculator);

        if (input.length) {

            var slider = input;
            var wrapper = input.parents('.sliderRange__wrapper');
            var currentValue = slider.slider('getValue');

            // update error message
            loan.updateAgeMaximumErrorMessage();

            // set slider step
            var ageStep = loan.activeTab.data.stepAge ? loan.activeTab.data.stepAge : 1;
            ageStep = Math.ceil(ageStep);
            input.attr('data-slider-step', ageStep);

            // set min and max values
            var age = loan.getVariantMaxAndMinAge();
            var maxAge = age.max;
            var minAge = age.min;
            input.attr('data-slider-max', maxAge);
            input.attr('data-slider-min', minAge);
            wrapper.find('[data-max]').html(loan.generateTranslatedNumber(maxAge));
            wrapper.find('[data-min]').html(loan.generateTranslatedNumber(minAge));

            $('input[data-algorithm-input="loanAge"]', loan.activeCalculator).attr("data-parsley-min", minAge);
            $('input[data-algorithm-input="loanAge"]', loan.activeCalculator).attr("data-parsley-max", maxAge);
            $(".age-min-max", loan.activeCalculator).find('[data-max]').html(loan.generateTranslatedNumber(maxAge));
            $(".age-min-max", loan.activeCalculator).find('[data-min]').html(loan.generateTranslatedNumber(minAge));
            // rebuild slider
            slider.slider('destroy');
            slider.slider();

            // update slider value
            if (setValue === 'urlParams') {

                var urlValue = parseInt(loan.urlParams.age);
                urlValue = urlValue && (urlValue >= minAge) && (urlValue <= maxAge) ? urlValue : minAge;
                wrapper.find('.qty').val(urlValue);
                wrapper.find('.valShow').html(loan.generateTranslatedNumber(urlValue));
                slider.slider('setValue', urlValue, true);
                $('input[data-algorithm-input="loanAge"]', loan.activeCalculator).val(urlValue);
                $('[name="loanAgeAr"]', loan.activeCalculator).val(loan.changeToArab(urlValue.toString().split("")));
                
            } else if (setValue === 'default' || currentValue > maxAge) {

                wrapper.find('.qty').val(minAge);
                wrapper.find('.valShow').html(loan.generateTranslatedNumber(minAge));
                slider.slider('setValue', minAge, true);
                $('input[data-algorithm-input="loanAge"]', loan.activeCalculator).val(minAge);
                $('[name="loanAgeAr"]', loan.activeCalculator).val(loan.changeToArab(minAge.toString().split("")));

            } else {

                wrapper.find('.qty').val(currentValue);
                wrapper.find('.valShow').html(loan.generateTranslatedNumber(currentValue));
                slider.slider('setValue', currentValue, true);
                $('input[data-algorithm-input="loanAge"]', loan.activeCalculator).val(currentValue);
                $('[name="loanAgeAr"]', loan.activeCalculator).val(loan.changeToArab(currentValue.toString().split("")));

            }

            // attach on slide event
            //loan.attachOnSlideEvent(slider, input, wrapper);

        }

    };


    /**
     * Update Age Maximum Error Message
     *
     */
    this.updateAgeMaximumErrorMessage = function() {

        var wrapper = $('[data-algorithm-input="age"]', loan.activeCalculator).parents('.sliderRange__wrapper');
        var currentAgeMax = loan.activeTab.data.maxAge;
        currentAgeMax = number_format(currentAgeMax, 0, genericSettings.decimal_number, genericSettings.separator_number);
        currentAgeMax = loan.generateTranslatedNumber(currentAgeMax);
        var valueString = '<span>' + currentAgeMax + '</span>';

        var errorMsg = wrapper.find('[data-max-error]').html();
        errorMsg = errorMsg.replace(/<span>(.*?)<\/span>/g, valueString); // replace <span>...</span>
        errorMsg = errorMsg.replace(/{value}/g, valueString); // replace {value}

        wrapper.find('[data-max-error]').html(errorMsg);

    };


    /**
     * Check Age Maximum
     *
     */
    this.checkAgeMaximum = function() {

        var wrapper = $('[data-algorithm-input="age"]', loan.activeCalculator).parents('.sliderRange__wrapper');
        var value = wrapper.find("input[data-algorithm-input=age]").val();

        var currentInterestTypeMax = parseInt(loan.activeTab.data.maxAge);

        if (value > currentInterestTypeMax) {
            wrapper.find('[data-max-error]').removeClass('hide');
        } else {
            wrapper.find('[data-max-error]').addClass('hide');
        }

    };


    /**
     * Update Tenor In Months Slider
     *
     */
    this.updateTenorInMonthsSlider = function(setValue) {

        var input = $('.rangeslider.rangeslider--3', loan.activeCalculator);

        if (input.length) {

            var slider = input;
            var wrapper = input.parents('.sliderRange__wrapper');
            var currentValue = slider.slider('getValue');

            // update error message
            loan.updateTenorMaximumErrorMessage();

            // set slider step
            var tenorStep = loan.activeTab.data.amountList[0].tenorScalingFactor ? loan.activeTab.data.amountList[0].tenorScalingFactor : 1;
            tenorStep = Math.ceil(tenorStep);
            input.attr('data-slider-step', tenorStep);

            // get tenor max and min
            var tenorMax = loan.getVariantMaximumTenor();
            var tenorMin = loan.activeTab.data.amountList[0].minimumTenor;

            // set tenor max and min text
            input.attr('data-slider-max', tenorMax);
            input.attr('data-slider-min', tenorMin);
            wrapper.find('[data-max]').html(loan.generateTranslatedNumber(tenorMax));
            wrapper.find('[data-min]').html(loan.generateTranslatedNumber(tenorMin));

            $('input[data-algorithm-input="loanDurationMobile"]', loan.activeCalculator).attr("data-parsley-min", slider.attr("data-slider-min"));
            $('input[data-algorithm-input="loanDurationMobile"]', loan.activeCalculator).attr("data-parsley-max", slider.attr("data-slider-max"));
            if(lang.indexOf("ar") > -1){
            	$(".tenor-slider-min-max", loan.activeCalculator).find('[data-max]').html(loan.changeToArab(slider.attr("data-slider-max").toString().split("")));
            	$(".tenor-slider-min-max", loan.activeCalculator).find('[data-min]').html(loan.changeToArab(slider.attr("data-slider-min").toString().split("")));
            } else {
            	$(".tenor-slider-min-max", loan.activeCalculator).find('[data-max]').html(slider.attr("data-slider-max"));
            	$(".tenor-slider-min-max", loan.activeCalculator).find('[data-min]').html(slider.attr("data-slider-min"));
            }
            // rebuild slider
            slider.slider('destroy');
            slider.slider();

            // if setValue urlParams
            if (setValue === 'urlParams') {

                var urlValue = parseInt(loan.urlParams.tenor);
                urlValue = urlValue && (urlValue >= tenorMin) && (urlValue <= tenorMax) ? urlValue : tenorMax;
                wrapper.find('.qty').val(urlValue);
                wrapper.find('.valShow').html(loan.generateTranslatedNumber(urlValue));
                slider.slider('setValue', urlValue, true);
                if(lang.indexOf("ar") > -1){
                	urlValue = loan.changeToArab(urlValue.toString().split(""));
                }
                $('input[data-algorithm-input="loanDurationMobile"]', loan.activeCalculator).val(urlValue);

            } else if (setValue === 'default' || currentValue > tenorMax) {

                wrapper.find('.qty').val(tenorMax);
                wrapper.find('.valShow').html(loan.generateTranslatedNumber(tenorMax));
                slider.slider('setValue', tenorMax, true);
                if(lang.indexOf("ar") > -1){
                	tenorMax = loan.changeToArab(tenorMax.toString().split(""));
                }
                $('input[data-algorithm-input="loanDurationMobile"]', loan.activeCalculator).val(tenorMax);

            } else {

                wrapper.find('.qty').val(currentValue);
                wrapper.find('.valShow').html(loan.generateTranslatedNumber(currentValue));
                slider.slider('setValue', currentValue, true);
                if(lang.indexOf("ar") > -1){
                	currentValue = loan.changeToArab(currentValue.toString().split(""));
                }
                $('input[data-algorithm-input="loanDurationMobile"]', loan.activeCalculator).val();

            }

            // attach on slide event
            loan.attachOnSlideEvent(slider, input, wrapper);
            input.trigger('change');

        }

    };


    /**
     * Attach On Slide Event
     *
     */
    this.attachOnSlideEvent = function(slider, input, wrapper) {

        slider.on('slide', function() {
            var value = slider.slider('getValue');
            wrapper.find('.qty').val(value);
            wrapper.find('.valShow').html(loan.generateTranslatedNumber(value));
            input.siblings('.qty').trigger('change');
        });

    };
    
    this.changeToArab = function(chars) {
    	var arabicNumbers = ['۰', '۱', '۲', '۳', '٤','٥','٦', '۷', '۸', '۹'];
        for (var i = 0; i < chars.length; i++) {
            if (parseFloat(chars[i]) > -1) {
                chars[i] = arabicNumbers[chars[i]];
            }
        }
        return chars.join('');
    }
    
    this.changeToLatin = function(arabic_number) {
    	try {
            var array_arab = arabic_number.split("");
            for (var i = 0; i < array_arab.length; i++) {
                switch (array_arab[i]) {
                    case "۰":
                    	array_arab[i] = "0";
                        break;
                    case "۱":
                    	array_arab[i] = "1";
                        break;
                    case "۲":
                    	array_arab[i] = "2";
                        break;
                    case "۳":
                    	array_arab[i] = "3";
                        break;
                    case "٤":
                    	array_arab[i] = "4";
                        break;
                    case "٥":
                    	array_arab[i] = "5";
                        break;
                    case "٦":
                    	array_arab[i] = "6";
                        break;
                    case "۷":
                    	array_arab[i] = "7";
                        break;
                    case "۸":
                    	array_arab[i] = "8";
                        break;
                    case "۹":
                    	array_arab[i] = "9";
                        break;
                    case ".":
                    	array_arab[i] = ".";
                        break;
                    case ",":
                        break;
                    default:
                    	array_arab[i] = arabic_number[i];
                }
            }
            return array_arab.join('');
        } catch (e) {
            return arabic_number
        }
    }


    /**
     * Update Tenor Maximum Error Message
     *
     */
    this.updateTenorMaximumErrorMessage = function() {

        var wrapper = $('[data-algorithm-input="tenorInMonths"]', loan.activeCalculator).parents('.sliderRange__wrapper');
        var currentInterestTypeMax = loan.getVariantMaximumTenor();
        currentInterestTypeMax = number_format(currentInterestTypeMax, 0, genericSettings.decimal_number, genericSettings.separator_number);
        currentInterestTypeMax = loan.generateTranslatedNumber(currentInterestTypeMax);
        var valueString = '<span>' + currentInterestTypeMax + '</span>';

        var errorMsg = wrapper.find('[data-max-error]').html();
        errorMsg = errorMsg.replace(/<span>(.*?)<\/span>/g, valueString); // replace <span>...</span>
        errorMsg = errorMsg.replace(/{value}/g, valueString); // replace {value}

        wrapper.find('[data-max-error]').html(errorMsg);

    };


    /**
     * Check Interest Type Tenor Maximum
     *
     */
    this.checkInterestTypeTenorMaximum = function() {

        var wrapper = $('[data-algorithm-input="tenorInMonths"]', loan.activeCalculator).parents('.sliderRange__wrapper');
        var value = $('[data-algorithm-input="tenorInMonths"]', loan.activeCalculator).val();
        var currentInterestTypeMax = loan.getVariantMaximumTenor();

        if (value > currentInterestTypeMax) {
            wrapper.find('[data-max-error]').removeClass('hide');
        } else {
            wrapper.find('[data-max-error]').addClass('hide');
        }

    };


    /**
     * Get Variant Max Age
     *
     */
    this.getVariantMaxAndMinAge = function() {

        var tabs = loan.activeVariant.data.glGenericCalculationList;
        var arr = [];

        // get age max and min for each tab
        tabs.forEach(function(item) {
            arr.push(item.maxAge);
            arr.push(item.minAge);
        });

        // select max and min value
        var maxAge = Math.max.apply(false, arr);
        var minAge = Math.min.apply(false, arr);

        return {
            'max': maxAge,
            'min': minAge
        };

    };


    /**
     * Get Variant Maximum Tenor
     *
     */
    this.getVariantMaximumTenor = function() {

        var tabs = loan.activeVariant.data.glGenericCalculationList;
        var arr = [];

        // get tenor maximum for each tab
        tabs.forEach(function(tab) {

            //La logica deve controllare se in questa tab il valore di isDefault corrisponde a quello selezionato nel form

            var isDefault = tab.isDefault == true ? "true" : "false";

            var productId = $("[name=productIdCalculator]").attr("value");

            if (productId != "100" && productId != "101" && productId != "102" && productId != "103") {

                loan.isdefaultElement = "true";

                isDefault = "true";
            }

            var interests = tab.interest;

            interests.forEach(function(interest) {

 				if (interest.interestCode === loan.activeInterestType.code && isDefault == loan.isdefaultElement || interests.length <= 1)
                    arr.push(interest.firstPeriod.monthDuration);
            });

        });

        // select maximum value
        var maximum = Math.max.apply(false, arr);

        return maximum;

    };


    /**
     * Update Loan Amount Input
     *
     */
    this.updateLoanAmountInput = function(setValue) {

        var input = $('[data-algorithm-input="loanAmount"]', loan.activeCalculator);

        if (input.length) {

            var minimumAmount = loan.activeTab.data.minimumAmount;
            var maximumAmount = loan.activeTab.data.maxAmountForOnline;
            var defaultAmount = loan.activeTab.data.defaultAmount;

            // update error messages
            loan.updateTextInputMinErrorMessage(minimumAmount, input);
            loan.updateTextInputMaxErrorMessage(maximumAmount, input);

            loan.setInputValue(input, minimumAmount, maximumAmount, defaultAmount, setValue, "loanAmount");
        }
       

        // validate input
        input.parsley().validate();
    };


    /**
     * Update Monthly Income Input
     *
     */
    this.updateMonthlyIncomeInput = function(setValue) {

        var input = $('[data-algorithm-input="monthlyNETIncome"]', loan.activeCalculator);

        if (input.length) {
            var minNetMonthlyIncome = loan.activeTab.data.minNetMonthlyIncome;
            var maxNetMonthlyIncome = loan.activeTab.data.maxNetMonthlyIncome;
            var defaultNetMonthlyIncome = loan.activeTab.data.defaultNetMonthlyIncome;

            // update error messages
            loan.updateTextInputMinErrorMessage(minNetMonthlyIncome, input);
            loan.updateTextInputMaxErrorMessage(maxNetMonthlyIncome, input);

            loan.setInputValue(input, minNetMonthlyIncome, maxNetMonthlyIncome, defaultNetMonthlyIncome, setValue, "monthlyIncome");

            // validate input
            input.parsley().validate();

        }

    };


    /**
     * Update Car Value Input
     *
     */
    this.updateCarValueInput = function(setValue) {

        var input = $('[data-algorithm-input="carValue"]', loan.activeCalculator);

        if (input.length) {

            var carMin = loan.activeTab.data.carMin;
            var carMax = loan.activeTab.data.carMax;
            var carDefault = loan.activeTab.data.defaultAmount; // default uguale a default amount

            // update error messages
            loan.updateTextInputMinErrorMessage(carMin, input);
            loan.updateTextInputMaxErrorMessage(carMax, input);

            loan.setInputValue(input, carMin, carMax, carDefault, setValue, "carValue");

            // validate input
            input.parsley().validate();

        }

    };


    /**
     * Update Text Input Min Error Message
     *
     */
    this.updateTextInputMinErrorMessage = function(value, input) {

        if (value !== null && value !== undefined) {

            // set error message
            input.attr('data-parsley-min', value);
            value = number_format(value, 0, genericSettings.decimal_number, genericSettings.separator_number);
            loan.setTextInputErrorMessage(input, value, 'data-parsley-min-message');

        } else {

            // remove error message
            input.removeAttr('data-parsley-min');

        }

    };


    /**
     * Update Text Input Max Error Message
     *
     */
    this.updateTextInputMaxErrorMessage = function(value, input) {

        if (value !== null && value !== undefined) {

            // set error message
            input.attr('data-parsley-max', value);
            value = number_format(value, 0, genericSettings.decimal_number, genericSettings.separator_number);
            loan.setTextInputErrorMessage(input, value, 'data-parsley-max-message');

        } else {

            // remove error message
            input.removeAttr('data-parsley-max');

        }

    };


    /**
     * Set Text Input Error Message
     *
     */
    this.setTextInputErrorMessage = function(input, value, attributeName) {

        // translate value
        value = loan.generateTranslatedNumber(value);

        var valueString = '<span>' + value + '</span>';

        var errorMsg = input.attr(attributeName);
        if (errorMsg) {
            errorMsg = errorMsg.replace(/<span>(.*?)<\/span>/g, valueString); // replace <span>...</span>
            errorMsg = errorMsg.replace(/{value}/g, valueString); // replace {value}


            input.attr(attributeName, errorMsg);
        }

    };


    /**
     * Get Default Variant Label
     *
     */
    this.getDefaultVariantLabel = function() {

        // get product variants array
        var variants = loan.productVariants;
        var numberOfVariants = variants.length;

        for (var i = 0; i < numberOfVariants; i++) {

            var isDefaultVariant = variants[i].isDefault;

            // if isDefault return it
            if (isDefaultVariant) {
                return variants[i].name;
            }

        }

    };


    /**
     * Set Active Tab
     *
     */
    this.setActiveTab = function(defaultValue, forceOpenTab) {

        // prevent not boolean values
        var tabDefaultValue = defaultValue === false ? false : true;

        // force open tab if not already open
        if (forceOpenTab) {
            var isTabOpen = $('[data-tab-default="' + tabDefaultValue + '"]', loan.activeCalculator).parent().hasClass('open');
            if (!isTabOpen) $('[data-tab-default="' + tabDefaultValue + '"]', loan.activeCalculator).trigger('click');
        }

        // get active variant tabs array
        var tabs = loan.activeVariant.data.glGenericCalculationList;
        var numberOftabs = tabs.length;
        var tabFound = false;

        for (var i = 0; i < numberOftabs; i++) {

            var isDefaultTab = tabs[i].isDefault;

            // if isDefault == true, set it
            if (isDefaultTab === tabDefaultValue) {
                loan.activeTab = {
                    'isDefault': tabs[i].isDefault,
                    'data': tabs[i]
                };
                var tabFound = true;
                break;
            }

        }

        // if tab not founded set default
        if (!tabFound) {
            loan.activeTab = {
                'isDefault': tabs[0].isDefault,
                'data': tabs[0]
            };
        }

    };


    /**
     * Update Interest Types Select
     *
     */
    this.updateInterestTypesSelect = function() {

        var interestTypes = loan.activeTab.data.interest;
        var numberOfInterestTypes = interestTypes.length;
        var select = $('[data-interest-select]', loan.activeCalculator);
        var html = '';

        // clear select
        select.html('');

        // generate options HTML
        var ind = 0;
        interestTypes.forEach(function(interestType) {

            var label = loan.calculatorLabels[interestType.interestCode];
            var value = interestType.firstPeriod.interestRate;
            var code = interestType.interestCode;
            var maxTenor = interestType.firstPeriod.monthDuration;

            // if it's the active one, add selected attribute
            if (interestType.interestCode === loan.activeInterestType.code) {
                html += '<option data-max-tenor="' + maxTenor + '" data-interest-code="' + code + '" value="' + value + '" selected>' + label + '</option>';
            } else {
                html += '<option data-max-tenor="' + maxTenor + '" data-interest-code="' + code + '" value="' + value + '">' + label + '</option>';
            }

			$("div[data-algorithm-input=newInterest]", loan.activeCalculator).children().find("input[type=radio]").each(function(index, element){
				console.log("index");
				if(index == ind){
					$(element).val(value);
					$(element).parent().find("span").text(label);
					if($(window).width() > 768){
						$(element).parents(".section__form__inline").css("display", "inline-block");
					} else {
						$(element).parents(".section__form__inline").css("display", "block");
					}
					ind = ind + 1;
					return false;
				}					
        	});

        });

        // append option HTML
        select.append(html);

        // update select disabled state
        loan.updateSelectDisabledProp(select, numberOfInterestTypes);

    };


    /**
     * Update Select Disabled Prop
     *
     */
    this.updateSelectDisabledProp = function(select, numberOfInterestTypes) {

        // if just 1 option, set select to disabled
        var disabledValue = numberOfInterestTypes <= 1 ? true : false;

        select.prop('disabled', disabledValue);

    };


    /**
     * Add Purpose Select Options
     *
     */
    this.mapProductVariants = function() {

        var productVariantsFromJson = loan.calculatorData.glGenericSimulatorParams.glProductVariantList;

        // generate an array with every product variant
        productVariantsFromJson.forEach(function(variant) {

            // if personal finance add all the subvariants
            if (variant.variantType === 'PERSONAL_FINANCE') {

                var subVariants = loan.getPersonalFinanceSubVariants();

                subVariants.forEach(function(subVariant) {
                    var defaultValue = subVariant === 'PERSONAL_USE' ? true : false;
                    loan.productVariants.push({
                        'name': subVariant,
                        'isDefault': defaultValue,
                        'data': variant.glConfigurationList[0]
                    });
                });

            } else {

                loan.productVariants.push({
                    'name': variant.variantType,
                    'isDefault': variant.default,
                    'data': variant.glConfigurationList[0]
                });

            }

        });

    };


    /**
     * Get Personal Finance SubVariants
     *
     */
    this.getPersonalFinanceSubVariants = function() {

        // get subvariants from calculatorLabels
        var subVariantsObj = loan.calculatorLabels.PERSONAL_FINANCE_OPTIONS;
        var subVariants = [];

        // fill array
        for (var subVariant in subVariantsObj) {
            subVariants.push(subVariant);
        }

        return subVariants;

    };


    /**
     * Add Purpose Select Options
     *
     */
    this.addPurposeSelectOptions = function() {

        //var productVariants = loan.productVariants;
        var html = '';

        var productMainVariants = loan.calculatorData.glGenericSimulatorParams.glProductVariantList;
        var mainVariantArray = [];
        // generate an array with every product variant
        productMainVariants.forEach(function(variant) {
        	mainVariantArray.push(variant.variantType);
        });
        
        // generate an option for each variant
        var ind = 0;
        loan.productVariants.forEach(function(variant) {

            var value = variant.name;
            var label = loan.calculatorLabels[variant.name] ? loan.calculatorLabels[variant.name] : (loan.calculatorLabels.PERSONAL_FINANCE_OPTIONS ? loan.calculatorLabels.PERSONAL_FINANCE_OPTIONS[variant.name] : undefined);

            // if it's the dafault one, add selected attribute
            if (variant.name === loan.activeVariant.name) {
                html += '<option value="' + value + '" selected>' + label + '</option>';
            } else {
                html += '<option value="' + value + '">' + label + '</option>';
            }
			$("div[data-algorithm-input=newPurpose]", loan.activeCalculator).children().find("input[type=radio]").each(function(index, element){
				console.log("index");
				if(index == ind){
					if(mainVariantArray.indexOf(value) >= 0  || value == "PERSONAL_USE"){
						$(element).val(value);
						$(element).parent().find("span").text(label);
						$(element).parents(".section__form__inline").css("display", "inline-block");
						ind = ind + 1;
						return false;
					}
				}					
			});

        });

        // append options HTML
        $('[data-purpose-select]', loan.activeCalculator).append(html);

    };

    this.addCommas = function(n) {
        var rx = /(\d+)(\d{3})/;

        return String(n).replace(/^\d+/, function(w) {

            while (rx.test(w)) {
                w = w.replace(rx, '$1,$2');
            }
            return w;
        });
    }

    this.setNumSystem = function(inputControlId) {

      //Set the minimum amount to the arabic input
    	setTimeout(function() {
              $('[name="monthlyNETIncomeValueAR"]', loan.activeCalculator).val($('[name="monthlyNETIncomeValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");
              $('[name="borrowAmoutValueAR"]', loan.activeCalculator).val($('[name="borrowAmoutValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");
              $('[name="carValueAR"]', loan.activeCalculator).val($('[name="borrowAmoutValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");
        }, 500);
        
/*

        var inputControl = $(inputControlId);

        var getJSON = {
            "arab": {
                "_digits": "٠١٢٣٤٥٦٧٨٩"
            }
        };
        var numbersList = getJSON.arab._digits;

        if (inputControl && inputControl.length > 0) {
            inputControl.keydown(function(event) {
                if (event.key >= 0 && event.key <= 9) {
                    event.preventDefault();
                    var s = inputControl.val();
                    var i = inputControl.prop('selectionStart');
                    s = s.substr(0, i) + loan.returnToArabicNumber(event.key) + s.substr(inputControl.selectionEnd);
                    if (s.length > 0) {
                        s = loan.returnToNumeric(s);
                        s = loan.addCommas(s);
                        s = loan.returnToArabicNumberFromArray(s.split(""));
                    }
                    inputControl.val(s);
                    inputControl.prop('selectionStart', inputControl.selectionEnd = s.length);
                } else if (numbersList.indexOf(event.key) > -1) {
                    event.preventDefault();
                    var s = inputControl.val();
                    var i = inputControl.prop('selectionStart');
                    s = s.substr(0, i) + event.key + s.substr(inputControl.selectionEnd);
                    if (s.length > 0) {
                        s = loan.returnToNumeric(s);
                        s = loan.addCommas(s);
                        s = loan.returnToArabicNumberFromArray(s.split(""));
                    }
                    inputControl.val(s);
                    inputControl.prop('selectionStart', inputControl.selectionEnd = s.length);
                } else if (event.key == ".") {
                    event.preventDefault();
                    var s = inputControl.val();
                    var i = inputControl.prop('selectionStart');
                    if (s.indexOf(".") < 0) {
                        s = s.substr(0, i) + event.key;
                        inputControl.val(s);
                        inputControl.prop('selectionStart', inputControl.selectionEnd = s.length);
                    }
                }


                var self = $(this);
                setTimeout(function() {
                    self.parsley().reset();
                    var number_toInt = parseInt(loan.returnToNumeric(self.val())) || 0;
                    var parsley_min = parseInt(self.attr('data-parsley-min')) || 1000;
                    if (number_toInt < parsley_min) {
                        self.parsley().validate();
                    }
                }, 200);


            });

            inputControl.bind("change", function(event) {
                var clipboardData, pastedData;
                var result = '5000';

                // Stop data actually being pasted into div
                event.stopPropagation();
                event.preventDefault();

                clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;
                if (clipboardData) {
                    pastedData = clipboardData.getData('text');
                } else {
                    pastedData = event && event.currentTarget ? event.currentTarget.value : '';
                }
                if (pastedData && pastedData.length > 0) result = loan.returnToArabicNumberFromArray(pastedData.split(""));
                inputControl.val(result);
            });

            inputControl.bind("paste", function(event) {
                var clipboardData, pastedData;
                var result = '5000';

                // Stop data actually being pasted into div
                event.stopPropagation();
                event.preventDefault();

                clipboardData = event.clipboardData || window.clipboardData || event.originalEvent.clipboardData;
                if (clipboardData) {
                    pastedData = clipboardData.getData('text');
                } else {
                    pastedData = event && event.currentTarget ? event.currentTarget.value : '';
                }
                if (pastedData && pastedData.length > 0) result = loan.returnToArabicNumberFromArray(pastedData.split(""));

                if (result.length > 0) {
                    result = loan.returnToNumeric(result);
                    result = loan.addCommas(result);
                    result = loan.returnToArabicNumberFromArray(result.split(""));
                }

                inputControl.val(result);
            });
    }
        */
    }

    this.changeValueInput = function(inputControlId) {
        var inputControl = $(inputControlId);

        if (inputControl && inputControl.length > 0) {
          /*  var result = loan.returnToArabicNumberFromArray(inputControl.val().split(""));
            setTimeout(function() { inputControl.val(result); }, 5);
            */

        }
    }


    //convert the numbers (arabic and latin)
    $(document).on("keypress keyup blur","[name=monthlyNETIncomeValueAR],[name=borrowAmoutValueAR],[name=carValueAR]",function(event){

        if ((event.which < 48 || event.which > 57)) {
            event.preventDefault();
        }
        var tv = $(this).val();
        var hiddenValueToConsider = $('[name="monthlyNETIncomeValue"]', loan.activeCalculator);
        if ($(this).attr("name")=="borrowAmoutValueAR"){
          hiddenValueToConsider = $('[name="borrowAmoutValue"]', loan.activeCalculator);
        }
        if ($(this).attr("name")=="carValueAR"){
          hiddenValueToConsider = $('[name="carValue"]', loan.activeCalculator);
        }
        if (tv.length>0){
          $(this).val($.latin2Arabic.toArabic(tv));
          hiddenValueToConsider.val($.latin2Arabic.toLatin(tv).replace(/\D/g,'')).parsley().validate();
          var tmpVal = hiddenValueToConsider.val();
          finalRes = parseInt(tmpVal).toLocaleString('ar-EG') ;
          $(this).val(finalRes);
        } else{
          hiddenValueToConsider.val("");
        }

        //simulate change on the input to be considered
        setTimeout(function() {
            hiddenValueToConsider.trigger("change");
        }, 50);


    });
    

    //if empty, set the minimum value
    $(document).on("focusout","[name=monthlyNETIncomeValueAR],[name=borrowAmoutValueAR],[name=carValueAR]",function(event){

      if ($(this).val()==""){
        if ($(this).attr("name")=="monthlyNETIncomeValueAR"){
          $('[name="monthlyNETIncomeValueAR"]', loan.activeCalculator).val($('[name="monthlyNETIncomeValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");
        }
        if ($(this).attr("name")=="carValueAR"){
          $('[name="carValueAR"]', loan.activeCalculator).val($('[name="borrowAmoutValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");
        }
        if ($(this).attr("name")=="borrowAmoutValueAR"){
          $('[name="borrowAmoutValueAR"]', loan.activeCalculator).val($('[name="borrowAmoutValue"]', loan.activeCalculator).attr("data-parsley-min")).trigger("keyup");
        }
      }

    });


    this.returnToArabicNumberFromArray = function(array_number) {
        var result = '';
        for (var i = 0; i < array_number.length; i++) {
            if (",.".includes(array_number[i])) {
                result += array_number[i];
            } else {
                result += loan.returnToArabicNumber(array_number[i]);
            }
        }
        return result
    }

    this.returnToArabicNumber = function(number) {
        var getJSON = {
            "arab": {
                "_digits": "٠١٢٣٤٥٦٧٨٩"
            }
        };
        var numbersList = getJSON.arab._digits;

        if (parseFloat(number) > -1) {
            return numbersList[number];
        } else if (number == "." || number == ",") {
            return number;
        } else {
            return number;
        }
    }

    this.returnToNumeric = function(arabic_number) {
        try {
            var array_arab = arabic_number.split("");
            var result = "";
            for (var i = 0; i < array_arab.length; i++) {
                switch (array_arab[i]) {
                    case "٠":
                        result += "0";
                        break;
                    case "١":
                        result += "1";
                        break;
                    case "٢":
                        result += "2";
                        break;
                    case "٣":
                        result += "3";
                        break;
                    case "٤":
                        result += "4";
                        break;
                    case "٥":
                        result += "5";
                        break;
                    case "٦":
                        result += "6";
                        break;
                    case "٧":
                        result += "7";
                        break;
                    case "٨":
                        result += "8";
                        break;
                    case "٩":
                        result += "9";
                        break;
                    case ".":
                        result += ".";
                        break;
                    case ",":
                        break;
                    default:
                        result = arabic_number;
                }
            }
            return result;
        } catch (e) {
            return arabic_number
        }


    };

    /**
     * Get Calculator Inputs
     *
     */
    this.getCalculatorInputs = function() {
        var inputs = $('[data-algorithm-input]', loan.activeCalculator);

        var percentage = parseFloat($(loan.activeCalculator).attr("data-loan-monthly-percentage-income"));

        for (var i = 0; i < inputs.length; i++) {

            var inputLabel = inputs[i].getAttribute('data-algorithm-input');
	            if(inputLabel != "newInterest" && inputLabel != "newPurpose"){
	            // format input, remove ','
	            var inputValue = inputs[i].value;
	
	            inputValue = inputValue.replace(/,/g, ''); // TODO: rendere dinamica la virgola all'interno della regex
	
	            //trasforma il numero arabo
	            if (inputs[i].getAttribute("class").indexOf("_arab_language") > -1) {
	                inputValue = loan.returnToNumeric(inputValue);
	            }
	            
	            if(inputLabel == "loanDurationMobile" || inputLabel == "loanAgeAr"){
	            	inputValue = loan.changeToLatin(inputValue);
	            }
	
	            inputValue = parseFloat(inputValue);
	            
	
	            // set value if it's valid
	            if (isNaN(inputValue)) {
	                loan.errorState = true;
	                break;
	            } else {
	                loan.errorState = false;
	                loan[inputLabel] = inputValue;
	            }
            } else {
            	loan.errorState = false;
            	var inputValue = inputs[i].value;
            	loan[inputLabel] = inputValue;
            }
        }

        // calculate 35 / 50 percent
        loan.monthlyNETIncome35Percent = loan.monthlyNETIncome * percentage;

    };


    /**
     * Append Calculator Outputs
     *
     */
    this.appendCalculatorOutputs = function() {

        var outputs = $('[data-algorithm-output]', loan.activeCalculator);
        var getLoanButton = $('.com16__buttonCover .btn', loan.activeCalculator);

        // toggle down payment line
        loan.toggleDownPaymentOutputLine();

        // if there are errors
        if (loan.errorState === true || loan.error35State === true || loan.errorCarState === true) {
            $('[data-algorithm-output]', loan.activeCalculator).text(loan.calculatorLabels.ERROR_VALUE);
            getLoanButton.addClass('disabled');
            return;
        }

        // if there're not errors
        getLoanButton.removeClass('disabled');

        outputs.each(function() {

            var inputLabel = $(this).attr('data-algorithm-output');
            var outputValue = loan[inputLabel];

            // format outputs
            if (inputLabel === 'monthlyInstallment' || inputLabel === 'downPayment') outputValue = number_format(loan[inputLabel], genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number);
            if (inputLabel === 'loanAmount') {
                outputValue = number_format(loan[inputLabel], 2, genericSettings.decimal_number, genericSettings.separator_number);
            }

            $(this).html(loan.generateTranslatedNumber(outputValue));

        });

    };


    /**
     * Toggle Down Payment Output Line
     *
     */
    this.toggleDownPaymentOutputLine = function() {

        var downPayment = loan.activeTab.data.downPayment;
        var downPaymentOutputLine = $('[data-algorithm-output="downPayment"]', loan.activeCalculator).parents('.com16__highlistItem');

        // show down payment line if it's not null
        if (downPayment !== null && downPayment !== undefined) {

            downPaymentOutputLine.removeClass('hide');

        } else {

            downPaymentOutputLine.addClass('hide');

        }

    };


    /**
     * Calculate Monthly Installment
     * Formula --> loanAmount*(annualInterestRate/100/12)/(1-(1/POTENZA((1+(annualInterestRate/100/12));tenorInMonths)))
     *
     */
    this.calculateMonthlyInstallment = function() {

        var dividend = loan.loanAmount * (loan.annualInterestRate / 100 / 12);

        var powerBase = 1 + (loan.annualInterestRate / 100 / 12);
        var powerExponent = loan.tenorInMonths;
        var power = Math.pow(powerBase, powerExponent);

        var divisor = 1 - (1 / power);

        var monthlyInstallment = dividend / divisor;

        loan.monthlyInstallment = parseFloat(monthlyInstallment.toFixed(2));
    };


    /**
     * Calculate Minimum Tenor
     * Formula --> ARROTONDA.PER.ECC(LOG((1/(1-((loanAmount*(annualInterestRate/100/12))/monthlyNETIncome35Percent)));(1+(annualInterestRate/100/12)));0)
     *
     */
    this.calculateMinimumTenor = function() {

        var logValueDivision = (loan.loanAmount * (loan.annualInterestRate / 100 / 12)) / loan.monthlyNETIncome35Percent;
        var logValue = 1 / (1 - logValueDivision);
        var logBase = 1 + (loan.annualInterestRate / 100 / 12);

        if (logValue <= 0 || logBase <= 0) return 10000;

        var log = Math.log(logValue) / Math.log(logBase);

        // round up
        var minimumTenor = Math.ceil(log);

        return minimumTenor;

    };


    /**
     * Calculate Maximum Loan Amount
     * Formula --> ARROTONDA.PER.DIF(monthlyNETIncome35Percent/((annualInterestRate/100/12)/(1-(1/POTENZA((1+(annualInterestRate/100/12));tenorInMonths))));0)
     *
     */
    this.calculateMaximumLoanAmount = function(tenorInMonths) {

        var dividend = loan.annualInterestRate / 100 / 12;

        var powerBase = 1 + (loan.annualInterestRate / 100 / 12);
        var powerExponent = tenorInMonths ? tenorInMonths : loan.tenorInMonths;
        var power = Math.pow(powerBase, powerExponent);

        var divisor = 1 - (1 / power);

        var mainDivisor = dividend / divisor;

        // calculate and round down
        var maximumLoanAmount = loan.monthlyNETIncome35Percent / mainDivisor;
        maximumLoanAmount = Math.floor(maximumLoanAmount);

        return maximumLoanAmount;

    };


    /**
     * Format Money Inputs
     *
     */
    this.formatMoneyInputs = function() {

        var inputToFormat = $('*[data-format-currency]', loan.activeCalculator);

        if (inputToFormat.length) {

            // NON VA BENE PER I NUMERI ARABI
            inputToFormat.each(function() {

                var cleave = new Cleave($(this), {

                    delimiter: genericSettings.separator,
                    numeral: true,
                    numeralDecimalMark: genericSettings.decimal,
                    numeralDecimalScale: 0,
                    numeralThousandsGroupStyle: 'thousand'

                });

            });

        }

    };


    /**
     * Show Error Message
     *
     */
    this.showErrorMessage = function() {

        var calculator = $('section.com16-11, section.com16-13');
        var errorMessage = $('.errorWsMessage');

        //calculator.addClass('hide');
        errorMessage.removeClass('hide');

    };


    /**
     * Console Log Values
     *
     */
    this.consoleLogValues = function() {

        console.log('-------------------------------------------------');
        console.log('variant name: ' + loan.activeVariant.name);
        console.log('loan amount: ' + loan.loanAmount);
        console.log('interest rate: ' + loan.annualInterestRate);
        console.log('tenor in months: ' + loan.tenorInMonths);
        console.log('monthly income: ' + loan.monthlyNETIncome);
        console.log('monthly income 35 percent: ' + loan.monthlyNETIncome35Percent);
        console.log('car value: ' + loan.carValue);
        console.log('down payment: ' + loan.downPayment);
        console.log('monthly installment: ' + loan.monthlyInstallment);
        console.log('-------------------------------------------------');

    };

    /**
     * Get the value from the input without formatting 
     * @returns the input value
     */
    this.getInputValue = function(input) {
        var inputValue = input.val();
        inputValue = inputValue.replace(/,/g, '').replaceAll(genericSettings.separator, "");
	
        //trasforma il numero arabo
        if (input.hasClass("_arab_language") > -1) {
            inputValue = loan.returnToNumeric(inputValue);
        }
            
        return parseFloat(inputValue);
    }

    /**
     * Set the input value after some calculator change based on the method 
     * @param $input the input as a jquery object
     * @param min the minimum value
     * @param max the maximum value
     * @param defaultValue the default value
     * @param {string} method urlParams - default or empty (current value)
     * @param {string} name the name to identify the input
     */
    this.setInputValue = function($input, min, max, defaultValue, method, name) {
        var value = undefined;

        if(method === 'urlParams'){
            value = parseInt(loan.urlParams[name]);
        }
        else if(method === 'default') {
            value = defaultValue;
        }else {
            value = loan.getInputValue($input);
        }
        
        value = value && (value >= min || min === null) && (value <= max || max === null) ? value : defaultValue;

        $input.val(value);
    }

    
    $.latin2Arabic = {
          _numerals: [
            {
              "arabic": "٠",
              "latin": "0",
              "html": "&#1632;"
            },
            {
              "arabic": "١",
              "latin": "1",
              "html": "&#1633;"
            },
            {
              "arabic": "٢",
              "latin": "2",
              "html": "&#1634;"
            },
            {
              "arabic": "٣",
              "latin": "3",
              "html": "&#1635;"
            },
            {
              "arabic": "٤",
              "latin": "4",
              "html": "&#1636;"
            },
            {
              "arabic": "٥",
              "latin": "5",
              "html": "&#1637;"
            },
            {
              "arabic": "٦",
              "latin": "6",
              "html": "&#1638;"
            },
            {
              "arabic": "٧",
              "latin": "7",
              "html": "&#1639;"
            },
            {
              "arabic": "٨",
              "latin": "8",
              "html": "&#1640;"
            },
            {
              "arabic": "٩",
              "latin": "9",
              "html": "&#1641;"
            }
        ],
        // Convert Latin to Arabic
        toArabic: function(number) {
            $.each(this._numerals, function(i,v) {
                number = number.replace(new RegExp(v.latin, 'g'), v.arabic);
                //console.log(number);
            });

            return number;
        },
        // Convert Arabic to Latin
        toLatin: function(number) {
            $.each(this._numerals, function(i,v) {
                number = number.replace(new RegExp(v.arabic, 'g'), v.latin);
                //console.log(number);
            });

            return number;
        },
        // Convert Arabic to Html
        toHtml: function(number) {
            $.each(this._numerals, function(i,v) {
                number = number.replace(new RegExp(v.arabic, 'g'), v.html);
                //console.log(number);
            });

            return number;
        }
      }
    

};

/**
 * Get class instance
 *
 */
Intesa.LoanCalculatorAlex.getInstance = function() {

    if (!window.intesa) {

        window.intesa = new Object();

    }

    if (!window.intesa.loan_calculator_alex) {

        window.intesa.loan_calculator_alex = new Intesa.LoanCalculatorAlex();

    }

    return window.intesa.loan_calculator_alex;

};
